/**
 * Unleash Feature Flag Integration
 *
 * This module provides the Unleash-specific configuration for feature flags.
 * It's used by the FeatureFlagProvider to connect to Unleash.
 *
 * If UNLEASH_URL is not configured, the provider will be disabled
 * and all remote flags will default to false.
 */

import { type IConfig, UnleashClient } from "unleash-proxy-client";

const url = window?.env?.UNLEASH_URL;

/**
 * Unleash configuration. Null if not configured.
 */
export const UNLEASH_CONFIG =
  url && url.trim() !== ""
    ? ({
        url,
        clientKey: window?.env?.UNLEASH_CLIENT_KEY ?? "default",
        appName: window?.env?.UNLEASH_APP_NAME ?? "algodash",
        refreshInterval: 15,
      } satisfies IConfig)
    : null;

export const UNLEASH_CLIENT = UNLEASH_CONFIG
  ? new UnleashClient(UNLEASH_CONFIG)
  : null;

/**
 * Whether Unleash is configured (UNLEASH_URL is set).
 */
export const UNLEASH_CONFIGURED = UNLEASH_CONFIG !== null;
